import { Box, Drawer, Portal } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { preventEscapeFromNestedPopup } from '@mangovoice/mango-ui'

interface SideSheetDialogProps {
  isOpen: boolean
  onClose: () => void
  title: ReactNode
  width?: string
  body: ReactNode
  footer?: ReactNode
}

export const SideSheetDialog = ({
  isOpen,
  onClose,
  title,
  width = '420px',
  body,
  footer,
}: SideSheetDialogProps) => {
  return (
    <Drawer.Root
      open={isOpen}
      onOpenChange={(details) => !details.open && onClose()}
      onEscapeKeyDown={preventEscapeFromNestedPopup}
      placement="end"
    >
      <Portal>
        <Drawer.Backdrop backdropFilter="blur(4px)" bg="bg.overlay" />
        <Drawer.Positioner>
          <Drawer.Content
            w={width}
            maxW="95vw"
            h="100vh"
            bg="bg.panel"
            borderRadius="none"
            boxShadow="xl"
            display="flex"
            flexDirection="column"
            position="fixed"
            top={0}
            right={0}
            m={0}
          >
            <Drawer.Header
              p={5}
              borderBottomWidth={1}
              borderColor="border.default"
            >
              <Drawer.Title fontSize="lg" fontWeight="semibold">
                {title}
              </Drawer.Title>
              <Drawer.CloseTrigger />
            </Drawer.Header>
            <Drawer.Body p={5} flex={1} overflowY="auto">
              {body}
            </Drawer.Body>
            {footer ? (
              <Box p={5} pt={4} borderTopWidth={1} borderColor="border.default">
                {footer}
              </Box>
            ) : null}
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  )
}
